export default __webpack_public_path__ + "static/media/FrameworkSpring.7293e051.epub";